import { type VariantProps, cva } from "class-variance-authority"
import type * as React from "react"
import { forwardRef } from "react"

import { cn } from "@/lib/utils"

const inputVariants = cva(
  "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input bg-background dark:bg-input/30 flex min-w-0 rounded-md border px-3 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      size: {
        default: "h-9 py-1 file:h-7",
        sm: "h-8 py-0.5 text-sm file:h-6",
        lg: "h-10 py-2 text-lg file:h-8",
        xl: "h-12 py-2.5 text-xl file:h-10"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
)

const Input = forwardRef<HTMLInputElement, React.ComponentProps<"input"> & VariantProps<typeof inputVariants>>(
  ({ className, type, size, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          inputVariants({ size }),
          className,
        )}
        {...props}
      />
    )
  }
)

Input.displayName = "Input"

export { Input }
